var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5 16.5409C20.2625 16.5409 21.9529 15.8129 23.1992 14.5172C24.4455 13.2215 25.1456 11.4642 25.1456 9.63176C25.1456 7.79935 24.4455 6.04199 23.1992 4.74629C21.9529 3.45058 20.2625 2.72266 18.5 2.72266C16.7375 2.72266 15.0471 3.45058 13.8008 4.74629C12.5545 6.04199 11.8544 7.79935 11.8544 9.63176C11.8544 11.4642 12.5545 13.2215 13.8008 14.5172C15.0471 15.8129 16.7375 16.5409 18.5 16.5409ZM18.5 19.5764C9.66423 19.5764 4 24.6457 4 27.1138V31.7227H33V27.1138C33 24.129 27.6376 19.5764 18.5 19.5764Z",
    fill: "#E0B959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/AboutIcon.2bd093d71357fb3da34b50b1dc794a09.svg";
export { ForwardRef as ReactComponent };